<script setup>
import { computed, onMounted, onUnmounted } from 'vue'

import { modalState } from '@/components/modal/modalHelper'
import PdfGenerationSuccessModal from '@/components/modal/modals/PdfGenerationSuccessModal.vue'
import PdfGenerationWarningModal from '@/components/modal/modals/PdfGenerationWarningModal.vue'
import PendingIssuesModal from '@/components/modal/modals/PendingIssuesModal.vue'

/**
 * Registry de modals disponíveis
 * Adicione novos modals aqui conforme necessário
 */
const modalComponents = {
  'pending-issues': PendingIssuesModal,
  'pdf-generation-warning': PdfGenerationWarningModal,
  'pdf-generation-success': PdfGenerationSuccessModal,
  // Exemplos futuros:
  // 'error': ErrorModal,
  // 'success': SuccessModal,
  // 'warning': WarningModal,
}

const currentModal = computed(() => {
  if (!modalState.show || !modalState.type) return null
  return modalComponents[modalState.type] || null
})

const resolve = action => {
  if (modalState.resolve) {
    modalState.resolve(action)
    modalState.resolve = null
  }
  modalState.show = false
  modalState.type = null
  modalState.options = {}
}

// Fechar com Escape
const onKeydown = e => {
  if (e.key === 'Escape' && modalState.show) {
    resolve(null)
  }
}

onMounted(() => {
  modalState.mounted = true
  document.addEventListener('keydown', onKeydown)
})

onUnmounted(() => {
  modalState.mounted = false
  document.removeEventListener('keydown', onKeydown)
})
</script>

<template>
  <component
    v-if="currentModal"
    :is="currentModal"
    :options="modalState.options"
    @resolve="resolve"
  />
</template>
